import type { InputHTMLAttributes, ReactNode, TextareaHTMLAttributes } from "react";

import { cn } from "@/lib/cn";

export interface FieldProps {
  id: string;
  label: string;
  hint?: ReactNode;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

/**
 * 表单字段容器。原型没有通用表单基元，这里复用原型的字号与间距令牌，
 * 不引入新的色值（提示文字沿用 `--ink-faint`）。
 */
export function Field({ id, label, hint, required, children, className }: FieldProps) {
  return (
    <div className={className} style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
      <label
        htmlFor={id}
        style={{ fontSize: "10px", letterSpacing: "0.08em", color: "var(--ink-faint)" }}
      >
        {label}
        {required ? <span style={{ color: "var(--red)" }}> *</span> : null}
      </label>
      {children}
      {hint ? <span className="inline-note">{hint}</span> : null}
    </div>
  );
}

export type TextInputProps = InputHTMLAttributes<HTMLInputElement>;

export function TextInput({ className, ...rest }: TextInputProps) {
  return <input className={cn(className)} {...rest} />;
}

export type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export function TextArea({ className, ...rest }: TextAreaProps) {
  return <textarea className={cn(className)} {...rest} />;
}
